import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Button, Typography, Alert, TextField } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import { authService } from '../../firebase/authService';


export default function AdminLogin() {
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [alreadyLogged, setAlreadyLogged] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loadingEmail, setLoadingEmail] = useState(false);
    const [showRegister, setShowRegister] = useState(false);
    const [registerEmail, setRegisterEmail] = useState('');
    const [registerPassword, setRegisterPassword] = useState('');
    const [registerLoading, setRegisterLoading] = useState(false);
    const [registerError, setRegisterError] = useState('');
    const [registerSuccess, setRegisterSuccess] = useState('');
    const [showReset, setShowReset] = useState(false);
    const [resetEmail, setResetEmail] = useState('');
    const [resetLoading, setResetLoading] = useState(false);
    const [resetError, setResetError] = useState('');
    const [resetSuccess, setResetSuccess] = useState('');
    // Função para registrar novo usuário
    const handleRegister = async (e) => {
        e.preventDefault();
        setRegisterError('');
        setRegisterSuccess('');
        setRegisterLoading(true);
        try {
            await authService.registerWithEmail(registerEmail, registerPassword);
            setRegisterSuccess('Usuário registrado com sucesso!');
            setRegisterEmail('');
            setRegisterPassword('');
        } catch (error) {
            setRegisterError(error.message || 'Erro ao registrar.');
        } finally {
            setRegisterLoading(false);
        }
    };

    // Função para resetar senha
    const handleResetPassword = async (e) => {
        e.preventDefault();
        setResetError('');
        setResetSuccess('');
        setResetLoading(true);
        try {
            await authService.sendPasswordResetEmail(resetEmail);
            setResetSuccess('Email de redefinição enviado! Verifique sua caixa de entrada e a caixa de spam.');
            setResetEmail('');
        } catch (error) {
            setResetError(error.message || 'Erro ao enviar email de redefinição.');
        } finally {
            setResetLoading(false);
        }
    };
    // Login com email e senha
    const handleEmailLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoadingEmail(true);
        try {
            const user = await authService.loginWithEmail(email, password);
            if (user && user.uid) {
                localStorage.setItem('admin_uid', user.uid);
            }
            navigate('/news-list');
        } catch (error) {
            setError(error.message || 'Falha na autenticação. Tente novamente.');
        } finally {
            setLoadingEmail(false);
        }
    };

    React.useEffect(() => {
        if (typeof window !== 'undefined' && localStorage.getItem('admin_uid')) {
            setAlreadyLogged(true);
        }
    }, []);

    // ...removido login do Google Drive...

    const handleGoogleLogin = async () => {
        setError('');
        setLoading(true);

        try {
            const user = await authService.loginWithGoogle();
            // Salva o UID do admin no localStorage
            if (user && user.uid) {
                localStorage.setItem('admin_uid', user.uid);
            }
            // Redirecionar para a última página que o usuário tentou acessar ou para a lista de notícias
            navigate('/news-list');
        } catch (error) {
            // Se a mensagem contém o UID, vamos formatá-la especialmente
            if (error.message.includes('UID')) {
                setError(
                    <div>
                        {error.message.split('\n').map((line, i) => (
                            <div key={i} style={{marginBottom: i === 0 ? '8px' : '0'}}>
                                {line}
                            </div>
                        ))}
                        <div style={{marginTop: '8px', fontSize: '0.9em', color: '#666'}}>
                            Use este UID para configurar seu acesso de administrador no Firebase Console
                        </div>
                    </div>
                );
            } else {
                setError(error.message || 'Falha na autenticação. Tente novamente.');
            }
            console.error('Erro no login:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="sm">
            <Box 
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    alignItems: 'center',
                }}
            >
                <Typography 
                    component="h1" 
                    variant="h4" 
                    sx={{ 
                        mb: 3,
                        fontFamily: 'Atlan',
                        color: '#0b2951',
                        fontWeight: 'bold'
                    }}
                >
                    Acesso Administrativo
                </Typography>

                {error && (
                    <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
                        {error}
                    </Alert>
                )}
                {/* ...removido interface de login do Google Drive... */}

                {!alreadyLogged ? (
                    <Box sx={{ mt: 3, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        {/* Login */}
                        {!showRegister && !showReset && (
                            <>
                                <Button
                                    onClick={handleGoogleLogin}
                                    fullWidth
                                    variant="contained"
                                    disabled={loading}
                                    startIcon={<GoogleIcon />}
                                    sx={{
                                        mt: 3,
                                        mb: 2,
                                        backgroundColor: '#DB4437',
                                        fontFamily: 'Atlan',
                                        '&:hover': {
                                            backgroundColor: '#C53929'
                                        }
                                    }}
                                >
                                    {loading ? 'Entrando...' : 'Entrar com Google'}
                                </Button>
                                <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
                                    Apenas administradores autorizados podem fazer login
                                </Typography>
                                <Box component="form" onSubmit={handleEmailLogin} sx={{ mt: 4, width: '100%' }}>
                                    <TextField
                                        label="Email"
                                        type="email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        fullWidth
                                        margin="normal"
                                        required
                                    />
                                    <TextField
                                        label="Senha"
                                        type="password"
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                        fullWidth
                                        margin="normal"
                                        required
                                    />
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        disabled={loadingEmail}
                                        sx={{ mt: 2, fontFamily: 'Atlan' }}
                                    >
                                        {loadingEmail ? 'Entrando...' : 'Entrar com Email e Senha'}
                                    </Button>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2, width: '100%' }}>
                                    <Typography
                                        sx={{ fontFamily: 'Atlan', color: 'primary.main', cursor: 'pointer', mb: 1, textDecoration: 'underline' }}
                                        onClick={() => { setShowRegister(true); setShowReset(false); }}
                                    >
                                        Registrar-se
                                    </Typography>
                                    <Typography
                                        sx={{ fontFamily: 'Atlan', color: 'primary.main', cursor: 'pointer', textDecoration: 'underline', mb:6 }}
                                        onClick={() => { setShowReset(true); setShowRegister(false); }}
                                    >
                                        Esqueci minha senha
                                    </Typography>
                                </Box>
                            </>
                        )}
                        {/* Registrar */}
                        {showRegister && !showReset && (
                            <Box component="form" onSubmit={handleRegister} sx={{ mt: 2, width: '100%' }}>
                                <Typography variant="h6" sx={{ fontFamily: 'Atlan', mb: 1 }}>Registrar novo usuário</Typography>
                                {registerError && <Alert severity="error">{registerError}</Alert>}
                                {registerSuccess && <Alert severity="success">{registerSuccess}</Alert>}
                                <TextField
                                    label="Email"
                                    type="email"
                                    value={registerEmail}
                                    onChange={e => setRegisterEmail(e.target.value)}
                                    fullWidth
                                    margin="normal"
                                    required
                                />
                                <TextField
                                    label="Senha"
                                    type="password"
                                    value={registerPassword}
                                    onChange={e => setRegisterPassword(e.target.value)}
                                    fullWidth
                                    margin="normal"
                                    required
                                />
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    disabled={registerLoading}
                                    sx={{ mt: 2, fontFamily: 'Atlan' }}
                                >
                                    {registerLoading ? 'Registrando...' : 'Registrar'}
                                </Button>
                                <Button
                                    variant="text"
                                    color="primary"
                                    onClick={() => { setShowRegister(false); }}
                                    sx={{ mt: 2, fontFamily: 'Atlan', width: '100%' }}
                                >
                                    Voltar para Login
                                </Button>
                            </Box>
                        )}
                        {/* Resetar senha */}
                        {showReset && !showRegister && (
                            <Box component="form" onSubmit={handleResetPassword} sx={{ mt: 2, width: '100%' }}>
                                <Typography variant="h6" sx={{ fontFamily: 'Atlan', mb: 1 }}>Redefinir senha</Typography>
                                {resetError && <Alert severity="error">{resetError}</Alert>}
                                {resetSuccess && <Alert severity="success">{resetSuccess}</Alert>}
                                <TextField
                                    label="Email"
                                    type="email"
                                    value={resetEmail}
                                    onChange={e => setResetEmail(e.target.value)}
                                    fullWidth
                                    margin="normal"
                                    required
                                />
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    disabled={resetLoading}
                                    sx={{ mt: 2, fontFamily: 'Atlan' }}
                                >
                                    {resetLoading ? 'Enviando...' : 'Enviar email de redefinição'}
                                </Button>
                                <Button
                                    variant="text"
                                    color="primary"
                                    onClick={() => { setShowReset(false); }}
                                    sx={{ mt: 2, fontFamily: 'Atlan', width: '100%' }}
                                >
                                    Voltar para Login
                                </Button>
                            </Box>
                        )}
                    </Box>
                ) : (
                    <Alert severity="info" sx={{ width: '100%', mt: 3 }}>
                        Você já está logado como administrador.
                    </Alert>
                )}
            </Box>
        </Container>
    );
}
